/**
 * frontend/RewardMoment.jsx
 * SoundDAO — Full-screen reward celebration.
 *
 * Used for both onboarding rewards and daily login rewards.
 * Shows "+X SOUND" with a "Claim your SOUND" button the user must press.
 * No auto-dismiss — the reward requires deliberate acknowledgement.
 * Tapping anywhere on the backdrop also claims/dismisses.
 */

import React, { useEffect } from 'react';
import './RewardMoment.css';

export default function RewardMoment({ persona, soundAwarded, agent, onComplete }) {
  // Web Audio API reward chime — C5 E5 G5 C6 ascending arpeggio
  useEffect(() => {
    if (localStorage.getItem('sounddao_mute_sfx') === 'true') return;
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const notes = [523.25, 659.25, 783.99, 1046.50];
      notes.forEach((freq, i) => {
        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.13;
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.15, t + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.50);
        osc.start(t);
        osc.stop(t + 0.50);
      });
    } catch (_) { /* AudioContext unavailable — silent fallback */ }
  }, []);

  const amount = soundAwarded ?? 100;

  return (
    <div
      className="reward-screen"
      style={{ '--accent': agent?.color || '#667eea', '--gradient': agent?.gradient }}
    >
      <div className="reward-inner">

        <div className="reward-ring reward-ring--outer" />
        <div className="reward-ring reward-ring--inner" />

        <div className="reward-emoji">{agent?.emoji || '🎵'}</div>

        <div className="reward-amount">
          <span className="reward-plus">+</span>
          <span className="reward-number">{amount.toLocaleString()}</span>
          <span className="reward-unit">SOUND</span>
        </div>

        <p className="reward-convert">
          Your points count toward SOUND, converted under a daily on-chain budget (at most 1 SOUND per point).
        </p>

        {agent?.agent && (
          <div className="reward-agent">
            <div className="reward-agent-icon">🤖</div>
            <p className="reward-agent-text">
              Your {agent.agentTitle} <strong>{agent.agent}</strong> is ready for you.
            </p>
          </div>
        )}

        <button className="reward-claim-btn" onClick={onComplete}>
          Claim your SOUND
        </button>

      </div>
    </div>
  );
}
